import React from 'react';

/** Interruptor accesible (role="switch"). size: 'md' | 'sm'. */
export default function Switch({ checked, onChange, disabled = false, label, size = 'md', id }) {
  const sm = size === 'sm';
  return (
    <button
      id={id} type="button" role="switch" aria-checked={!!checked} aria-label={label} disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className={`relative flex-shrink-0 rounded-full transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-live focus-visible:ring-offset-2 focus-visible:ring-offset-ink
        disabled:opacity-40 disabled:cursor-not-allowed ${checked ? 'bg-live' : 'bg-fg/15'} ${sm ? 'h-[17px] w-[30px]' : 'h-[22px] w-[38px]'}`}
    >
      <span aria-hidden className={`absolute left-[3px] top-1/2 -translate-y-1/2 rounded-full bg-white shadow transition-transform duration-150 motion-reduce:transition-none
        ${sm ? 'h-[11px] w-[11px]' : 'h-4 w-4'} ${checked ? (sm ? 'translate-x-[13px]' : 'translate-x-4') : ''}`} />
    </button>
  );
}
